/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import theme from 'shared/assets/style/theme';
import ImageBW from '../../components/ImageBoundsWrapper';
import CopySelector from 'shared/utils/copySelector';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { isHri } from 'shared/utils/targetApplication';
import { purchaseActionTriggers } from 'shared/constants/userActions';

const ORANGE_BUTTON = require(asset`RoundedRect_Orange@3x.png`);
const GREEN_BUTTON = isHri ? require(asset`RoundedRect_Pink@3x.png`) : require(asset`RoundedRect_Green@3x.png`);
const GREY_BUTTON = require(asset`RoundedRect_Grey@3x.png`);

/** @typedef {import('shared/api/Constants').BoostPackageItem} BP */

/** @param {BP} item */
export default function makeVIPItem(
  item,
  index,
  buyHandle,
  freeHandle,
  activeVIPAcess,
  hasVIPPass,
  isVipRoomUnlocked,
  themeContext
) {
  const headerImg = [
    require(asset`images/Coin_Store_Assets/VIP_Tiles/VIP_Hour_Tile_1@3x.png`),
    require(asset`images/Coin_Store_Assets/VIP_Tiles/VIP_Hour_Tile_2@3x.png`),
    require(asset`images/Coin_Store_Assets/VIP_Tiles/VIP_Hour_Tile_3@3x.png`),
  ];

  const logos = [
    require(asset`images/Coin_Store_Assets/VIP_Tiles/VIP_Hour_Tile_1star@3x.png`),
    require(asset`images/Coin_Store_Assets/VIP_Tiles/VIP_Hour_Tile_2stars@3x.png`),
    require(asset`images/Coin_Store_Assets/VIP_Tiles/VIP_Hour_Tile_3stars@3x.png`),
  ];

  const freeImg = require(asset`images/Coin_Store_Assets/VIP_Tiles/VIP_Hour_Tile_FREE@3x.png`);

  const actionButton = activeVIPAcess || isVipRoomUnlocked ? GREY_BUTTON : item.is_free ? ORANGE_BUTTON : GREEN_BUTTON;

  return (
    <ImageBW
      source={item.is_free ? freeImg : headerImg[index]}
      ibw={require(asset`images/Coin_Store_Assets/VIP_Tiles/VIP_Hour_Tile.ibw`)}
      manualAssetScale={3}
      key={'vip-' + item.item_id}
      style={{
        width: '32%',
        height: '90%',
      }}
      innerStyle={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.common[1],
      }}
    >
      <img src={logos[index]} style={themeContext.VIPItem.LogoImage} />
      <div style={themeContext.VIPItem.DurationFriendlyFull}>{item.duration_friendly_full}</div>
      <div style={{ fontSize: '2vmin' }}>{`${CopySelector.getCopy(CopySelector.COPY_TYPES.VIP)} Access`}</div>
      {!item.is_free && (
        <>
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              height: '26%',
              width: '100%',
            }}
          >
            <div style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>{getText(TEXT_KEY.PLUS_SYMBOL)}</div>
            <ImageBW
              source={require(asset`Star_Icon.png`)}
              ibw={require(asset`Star_Icon.ibw`)}
              style={{ height: 30, width: 30, objectFit: 'contain', margin: '0 1em' }}
            />
            <div style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>{item.bonus_loyalty_points || '0'}</div>
          </div>
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 500,
            }}
          >
            <div style={{ fontSize: '1.3rem' }}>${item.price}</div>
          </div>
        </>
      )}
      {item.is_free && (
        <>
          <div
            style={{
              position: 'relative',
              marginTop: '1vmin',
              flex: 1,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                position: 'absolute',
                height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div style={{ fontSize: '6vmin', fontWeight: 'bold' }}>{getText(TEXT_KEY.FREE)}</div>
            </div>
          </div>
        </>
      )}
      <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
        <ImageBW
          source={actionButton}
          ibw={require(asset`RoundedRect.ibw`)}
          manualAssetScale={3}
          style={{
            objectFit: 'contain',
            width: '70%',
            height: '4.5rem',
            cursor: 'pointer',
          }}
          innerStyle={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            pointerEvents: 'auto',
          }}
          onClick={() =>
            activeVIPAcess || isVipRoomUnlocked
              ? hasVIPPass()
              : item.is_free
              ? freeHandle(item.item_id, 'vip_room_access')
              : buyHandle(item.item_id, item.name, 'vip_room_access', item.price, purchaseActionTriggers.STORE_VIP_ITEM)
          }
        >
          {activeVIPAcess ? (
            item.is_free ? (
              <p
                style={{
                  fontWeight: 'bold',
                  fontSize: '2.5rem',
                  lineHeight: '5rem',
                  margin: 0,
                }}
              >
                {getText(TEXT_KEY.GET)}
              </p>
            ) : (
              <p
                style={{
                  fontWeight: 'bold',
                  fontSize: '2.5rem',
                  lineHeight: '5rem',
                  margin: 0,
                }}
              >
                {getText(TEXT_KEY.BUY)}
              </p>
            )
          ) : (
            <img
              src={item.is_free ? require(asset`RasterText_GET@3x.png`) : require(asset`RasterText_BUY@3x.png`)}
              style={{ height: '50%', width: '45%', objectFit: 'contain' }}
            />
          )}
        </ImageBW>
      </div>
    </ImageBW>
  );
}

